export default {
    "Reset Password": {
        token: "sampletoken",
        email: "johndoe@sample.com",
        avatar: "https://www.gravatar.com/avatar/EMAIL_HASH?d=identicon",
        phone: "+12125551212",
        expires: "2028-12-31 23:59:59"
    },
    "Survey Invitation": {
        token: "VEYL4A7RL3"
    },
    "Calendar Event": {
        uuid: 'b0e704a0-5dee-4adf-b102-6ef0db523bd5',
        status: 'tentative',
        style: 'event',
        title: 'Test II',
        description: '<p><br></p>', 
        allDay: false,
        endsAt: '2026-01-20T19:30:00.000Z',
        location: '',
        recurrence: '',
        startsAt: '2026-01-20T18:30:00.000Z',
        timezones: [
            { commonName: 'America/New_York', startsAt: 'January 20, 2026 at 1:30 PM', endsAt: 'January 20, 2026 at 2:30 PM' }
        ],
        ics: 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Feradel//Calendar//EN\r\nCALSCALE:GREGORIAN\r\nMETHOD:PUBLISH\r\nX-WR-CALNAME:Event\r\nBEGIN:VEVENT\r\nUID:b0e704a0-5dee-4adf-b102-6ef0db523bd5\r\nDTSTAMP:20260120T222042Z\r\nDTSTART:20260120T183000Z\r\nDTEND:20260120T193000Z\r\nSUMMARY:Test II\r\nDESCRIPTION:<p><br></p>\r\nEND:VEVENT\r\nEND:VCALENDAR\r\n',
        attendees: [
            {
                firstName: 'Kenny',
                lastName: 'Screwem',
                mark: 'busy',
                phone: '+1',
                role: 'opt',
                status: 'invited',
                uuid: '2dba03b0-1d49-4cc2-bacc-8a308b441460',
                invitedBy: {
                    displayName: 'System Administrator',
                    email: 'administrator@valinelaw.com',
                    firstName: 'System',
                    lastName: 'Administrator',
                    phone: '+15713820603',
                    userUuid: 'a00aea32-b647-425c-afed-96a0db31d69d',
                    uuid: '3927c8df-dc05-479d-9ba3-62966e6217df'
                }
            }
        ],
        calendar: {
            uuid: '9bcb971a-b51b-47f9-bd81-fac901bd5877',
            name: 'Firm',
            role: 'unknown'
        },
        createdBy: {
            uuid: '3927c8df-dc05-479d-9ba3-62966e6217df',
            displayName: 'System Administrator',
            firstName: 'System',
            lastName: 'Administrator',
            email: 'administrator@valinelaw.com',
            phone: '+15713820603',
            userUuid: 'a00aea32-b647-425c-afed-96a0db31d69d'
        },
        case: {
            caption: 'Doe v. Doe',
            number: 'CL20-01234',
            status: 'Pending',
            uuid: '6774b79f-b8b8-4699-b11c-f1743bf64d07'
        },
        person: {
            displayName: 'Kenny Screwem',
            email: 'lawyer@valinelaw.com',
            firstName: 'Kenny',
            lastName: 'Screwem',
            phone: '+1',
            userUuid: '1710304c-6d4b-4b3a-84cf-f45f14c0c979',
            uuid: '6826634b-e368-46ef-b916-b457d26451f5'
        }
    },
    "Signing Notification": {
        event: {
            type: "initial",
            templateName: "SIGNING.INITIAL",
            occurredAt: "2026-06-26T14:30:00.000Z",
            signingUrl: "https://sign.feradel.com/public/sign/sample-token",
            expirationAt: "2026-07-26T23:59:59.000Z"
        },
        envelope: {
            uuid: "944a1d27-6530-45e9-9d8f-fb8926bd61ed",
            title: "Fee Agreement",
            displayName: "Fee Agreement",
            subject: "Please sign the fee agreement",
            messageBody: "Please review and sign this document.",
            status: "sent",
            routingMode: "grouped",
            matterUuid: "6774b79f-b8b8-4699-b11c-f1743bf64d07",
            personUuid: "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
            firmUuid: "715c9ebb-0470-11f1-a928-0ed2cd1b87df",
            senderUuid: "3927c8df-dc05-479d-9ba3-62966e6217df",
            sentAt: "2026-06-26T14:29:12.000Z",
            expirationAt: "2026-07-26T23:59:59.000Z",
            timeZone: "America/New_York",
            sourceSystem: "matters.firm"
        },
        document: {
            uuid: "0c5fe094-85d6-48cc-9e12-ad8814d54df3",
            displayName: "Fee Agreement",
            originalFileName: "Fee Agreement.pdf",
            sourceFileUuid: "6dd51641-b240-45cd-b2e9-35c4d4fe93f1",
            workingFileUuid: "16690db9-dcd7-4722-942c-7d4f8e3e0fe5",
            signedFileUuid: "a2435386-fdad-4a9e-b5ad-2a9778ebf59f",
            completedFileUuid: "f9c83685-3157-4f08-9862-cf0759757858",
            filename: "Fee Agreement fully signed 2026-06-26.pdf",
            mimeType: "application/pdf",
            pageCount: 5,
            documentOrder: 0
        },
        documents: [
            {
                uuid: "0c5fe094-85d6-48cc-9e12-ad8814d54df3",
                displayName: "Fee Agreement",
                originalFileName: "Fee Agreement.pdf",
                sourceFileUuid: "6dd51641-b240-45cd-b2e9-35c4d4fe93f1",
                workingFileUuid: "16690db9-dcd7-4722-942c-7d4f8e3e0fe5",
                filename: "Fee Agreement.pdf",
                mimeType: "application/pdf",
                pageCount: 5,
                documentOrder: 0
            }
        ],
        recipient: {
            uuid: "53ee4f54-09b1-4c88-ad93-4a7d580e86d9",
            personUuid: "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
            name: "Ima Outsider",
            email: "imaoutsider@valinelaw.com",
            role: "Client",
            recipientType: "signer",
            routingOrder: 1,
            isRequired: true,
            status: "email_sent"
        },
        recipients: [
            {
                uuid: "53ee4f54-09b1-4c88-ad93-4a7d580e86d9",
                name: "Ima Outsider",
                email: "imaoutsider@valinelaw.com",
                role: "Client",
                recipientType: "signer",
                routingOrder: 1,
                isRequired: true,
                status: "email_sent"
            },
            {
                uuid: "1377796f-ee03-493e-9fec-84c7c87376ed",
                name: "Kenny Screwem",
                email: "lawyer@valinelaw.com",
                role: "Attorney",
                recipientType: "signer",
                routingOrder: 1,
                isRequired: false,
                status: "pending"
            },
            {
                uuid: "a3e76ba6-435c-4fe3-8332-dfbe0d96717c",
                name: "Records",
                email: "records@valinelaw.com",
                recipientType: "cc",
                isRequired: false,
                status: "pending"
            }
        ]
    },
    "Lead CRM Campaign": {
        Lead: {
            uuid: "11111111-1111-4111-8111-111111111111",
            subject: "Uncontested divorce consultation",
            status: "OPEN",
            stage: 1,
            source: "website",
            sourceDetail: "Public lead form",
            nextFollowUpAt: "2026-07-04T14:00:00.000Z",
            lastContactedAt: null,
            lastActivityAt: "2026-07-03T14:00:00.000Z",
            probability: 70,
            estimatedValue: "2500.00",
            primaryArea: "family",
            secondaryArea: "divorce",
            timeline: 30,
            intent: 80,
            fit: 75,
            meta: {
                intent: {
                    subtotal: 2500,
                    addons: 0,
                    total: 2500,
                    products: [
                        {
                            name: "Uncontested Divorce",
                            term: "Flat-fee uncontested divorce",
                            amount: 2500
                        }
                    ]
                },
                SOURCE: "website",
                STATE: "FL",
                KIDS: "no",
                ISSUES: "none",
                PROPERTY: "minimal",
                TIMELINE: "30 days",
                AGREEMENT: "yes",
                ACTIVE_DISPUTE: "no"
            }
        },
        lead: {
            uuid: "11111111-1111-4111-8111-111111111111",
            subject: "Uncontested divorce consultation",
            status: "OPEN",
            source: "website"
        },
        Person: {
            uuid: "11111111-1111-4111-8111-111111111111",
            displayName: "Jane Client",
            firstName: "Jane",
            middleName: "",
            lastName: "Client",
            email: "jane.client@example.com",
            phone: "+15555551212"
        },
        person: {
            uuid: "11111111-1111-4111-8111-111111111111",
            displayName: "Jane Client",
            firstName: "Jane",
            lastName: "Client",
            email: "jane.client@example.com",
            phone: "+15555551212"
        },
        Campaign: {
            uuid: "22222222-2222-4222-8222-222222222222",
            name: "consultation-followup-1-3-7-weekly",
            caption: "Consultation Follow-up 1-3-7 Weekly",
            description: "Sends follow-up emails 1 day, 3 days, and 7 days after enrollment, then weekly.",
            default: true,
            selectable: true,
            enabled: true,
            sortOrder: 10
        },
        campaign: {
            uuid: "22222222-2222-4222-8222-222222222222",
            name: "consultation-followup-1-3-7-weekly",
            caption: "Consultation Follow-up 1-3-7 Weekly"
        },
        CampaignMembership: {
            uuid: "33333333-3333-4333-8333-333333333333",
            leadUuid: "11111111-1111-4111-8111-111111111111",
            campaignUuid: "22222222-2222-4222-8222-222222222222",
            status: "ACTIVE",
            startedAt: "2026-07-03T14:00:00.000Z",
            nextRunAt: "2026-07-04T14:00:00.000Z"
        },
        campaignMembership: {
            uuid: "33333333-3333-4333-8333-333333333333",
            status: "ACTIVE"
        },
        OptOut: {
            url: "",
            href: "",
            label: "Opt out",
            text: "Opt out of CRM email campaigns"
        },
        optOut: {
            url: ""
        },
        Unsubscribe: {
            url: ""
        },
        unsubscribe: {
            url: ""
        },
        unsubscribeUrl: "",
        emailCampaignOptOutUrl: "",
        custom: {
            optOutUrl: "",
            unsubscribeUrl: "",
            emailCampaignOptOutUrl: ""
        }
    },
    "Invoice": {
        uuid: '353c076d-5a66-4f69-bba6-79a559c818a8',
        currentExpenses: '2.58',
        currentGross: '227.58',
        currentMinutes: 30,
        currentNet: '227.50',
        currentServices: '225.00',
        currentWriteOffs: '0.08',
        due: '2026-01-03T18:17:26.000Z',
        generated: '2026-01-03T18:17:26.000Z',
        interestCharge: '0.00',
        interestRate: '18.0000',
        number: 1001,
        paymentsMade: '1500.00',
        paymentRequired: '3727.50',
        previousBalance: '0.00',
        published: null,
        sent: null,
        staffUuid: 'e1ec0ab7-5123-11f0-a2ef-0ed2cd1b87df',
        totalBalance: '-1272.50',
        trustEnd: '1272.50',
        trustStart: '0.00',
        Firm: {
            legalName: "Dewey, Screwem, & Howe PC",
            alias: "DSH",
            initialFee: 75,
            checkFee: 45,
            signature: {
                name: "Destin Valine, esq.",
                email: "destin@valinelaw.com"
            }
        },
        Person: {
            uuid: "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
            displayName: "Ima Outsider",
            firstName: "Ima",
            middleName: "",
            lastName: "Outsider",
            generation: "",
            email: "imaoutsider@valinelaw.com",
            phone: "+12125551000",
            fax: "+12125551005",
            communicationPreferences: 3,
            Residence: {
                uuid: "1e30f3f4-2446-4a24-b722-69665271d3d2",
                country: "US",
                line1: "123 Sesame Street",
                city: "New York",
                state: "NY",
                county: "New York",
                zipCode: "11021"
            },
        },
        Clocks: [
            {
                uuid: '72e6292c-7dcb-4826-a62f-7b61822ab9f3',
                ended: '2025-12-31T15:50:08.000Z',
                gross: '90.00',
                minutes: 12,
                net: '90.00',
                notes: 'General advice / consultation',
                rate: '450.00',
                started: '2025-12-31T15:38:08.000Z',
                writeOff: '0.00',
                Staff: {
                    uuid: '6826634b-e368-46ef-b916-b457d26451f5',
                    title: 'Sr. Attorney',
                    Person: {
                        uuid: "6826634b-e368-46ef-b916-b457d26451f5",
                        displayName: "Kenny Screwem",
                        firstName: "Kenny",
                        middleName: "",
                        lastName: "Screwem",
                        generation: "",
                        email: "lawyer@valinelaw.com",
                        phone: "+12125551000",
                    }
                }
            },
            {
                uuid: '98b36be0-1c59-4c3a-b34c-55b362de5ed8',
                ended: '2026-01-02T18:36:47.000Z',
                gross: '135.00',
                minutes: 18,
                net: '135.00',
                notes: 'Client communication',
                rate: '450.00',
                started: '2026-01-02T18:18:47.000Z',
                writeOff: '0.00',
                Case: {
                    uuid: '6774b79f-b8b8-4699-b11c-f1743bf64d07',
                    caption: 'Doe v. Doe',
                    caseNumber: 'CL25-000001',
                    status: 'Pending',
                    style: 'Domestic'
                },
                Staff: {
                    uuid: '6826634b-e368-46ef-b916-b457d26451f5',
                    title: 'Sr. Attorney',
                    Person: {
                        uuid: "6826634b-e368-46ef-b916-b457d26451f5",
                        displayName: "Kenny Screwem",
                        firstName: "Kenny",
                        middleName: "",
                        lastName: "Screwem",
                        generation: "",
                        email: "lawyer@valinelaw.com",
                        phone: "+12125551000",
                    }
                }
            }
        ],
        Expenses: [
            {
                uuid: 'f235d9da-f755-44d6-90f4-c4f4df7e4556',
                expended: '2026-01-02T19:10:31.000Z',
                gross: '2.58',
                merchant: 'Valine Law',
                net: '2.50',
                notes: 'Catalog Envelopes (1 @ $2) | Copies (1 @ $0.08)',
                writeOff: '0.08',
                Staff: {
                    uuid: '6826634b-e368-46ef-b916-b457d26451f5',
                    title: 'Sr. Attorney',
                    Person: {
                        uuid: "6826634b-e368-46ef-b916-b457d26451f5",
                        displayName: "Kenny Screwem",
                        firstName: "Kenny",
                        middleName: "",
                        lastName: "Screwem",
                        generation: "",
                        email: "lawyer@valinelaw.com",
                        phone: "+12125551000",
                    }
                }
            }
        ],
        Payments: [
            {
                uuid: '3bdfc9f7-34d6-43ca-8622-5e59322198a6',
                gross: '1500.00',
                recorded: '2026-01-01T05:00:00.000Z',
                reference: '123456',
                source: 'LP',
                Staff: {
                    uuid: '6826634b-e368-46ef-b916-b457d26451f5',
                    title: 'Sr. Attorney',
                    Person: {
                        uuid: "6826634b-e368-46ef-b916-b457d26451f5",
                        displayName: "Kenny Screwem",
                        firstName: "Kenny",
                        middleName: "",
                        lastName: "Screwem",
                        generation: "",
                        email: "lawyer@valinelaw.com",
                        phone: "+12125551000",
                    }
                }
            }
        ]
    },
    "Lead": {
        Firm: {
            legalName: "Dewey, Screwem, & Howe PC",
            alias: "DSH",
            initialFee: 75,
            checkFee: 45,
            signature: {
                name: "Destin Valine, esq.",
                email: "destin@valinelaw.com"
            }
        },
        Surveys: [
            {
                meta: {
                    key: "C7BGN6ECFH"
                }
            }
        ],
        Person: {            
            uuid: "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
            displayName: "Ima Outsider",
            firstName: "Ima",
            middleName: "",
            lastName: "Outsider",
            generation: "",
            email: "imaoutsider@valinelaw.com",
            ssn: null,
            birthDate: null,
            deceasedDate: null,
            phone: "+12125551000",
            fax: "+12125551005",
            communicationPreferences: 3,
            gender: "unknown",
            religion: null,
            race: "unknown",
            flags: 6,
            Residence: {
                uuid: "1e30f3f4-2446-4a24-b722-69665271d3d2",
                country: "US",
                line1: "123 Sesame Street",
                city: "New York",
                state: "NY",
                county: "New York",
                zipCode: "11021"
            },
        },
        Lead: {
            budget: "0.00",
            fit: 8,
            intent: 4,
            minutes: 6,
            primaryArea: "business",
            secondaryArea: "civil",
            retainer: "10000.00",
            source: "unsourced",
            sourceDetail: null,
            stage: 0,
            status: 0,
            subject: "breach of contract against Acme, Inc. related to defective TNT",
            timeline: 5,
            rates: [
                {code: 'PF', name: 'Prefiling', uuid: '210e4c9c-4213-43fc-a68d-041b88a07111', index: 0, style: 'C', value: 25},
                {code: 'PT', name: 'Pretrial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07112', index: 1, style: 'C', value: 27.5},
                {code: 'PX', name: 'Trial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07113', index: 1, style: 'C', value: 30},
                {code: 'PY', name: 'Post Trial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07114', index: 2, style: 'C', value: 35},
                {code: 'AD', name: 'Paralegal', uuid: '210e4c9c-4213-43fc-a68d-041b88a07115', index: 0, style: 'H', value: 225},
                {code: 'AS', name: 'Associate', uuid: '210e4c9c-4213-43fc-a68d-041b88a07116', index: 1, style: 'H', value: 325},
                {code: 'AP', name: 'Partner', uuid: '210e4c9c-4213-43fc-a68d-041b88a07117', index: 2, style: 'H', value: 425}
            ],
            CaseLocation: {
                uuid: "1e30f3f4-2446-4a24-b722-69665271d3d3",
                country: "US",
                line1: "456 Sesame Street",
                city: "New York",
                state: "NY",
                county: "New York",
                zipCode: "11020"
            },
        },
        Client: {
            billedExpenses: "122.10",
            billedTime: "300.00",
            due: "0.00",
            lastInvoiced: "2025-12-14T23:05:35.000Z",
            minutes: 10,
            retainer: 5000,
            retainerAsOf: "2025-12-14T23:05:36.000Z",
            terminationDate: null,
            terminationStyle: "",
            trust: "9637.90",
            writeOffs: "50.00",
            rates: [
                {code: 'PF', name: 'Prefiling', uuid: '210e4c9c-4213-43fc-a68d-041b88a07111', index: 0, style: 'C', value: 30},
                {code: 'PT', name: 'Pretrial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07112', index: 1, style: 'C', value: 37.5},
                {code: 'PX', name: 'Trial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07113', index: 1, style: 'C', value: 45},
                {code: 'PY', name: 'Post Trial', uuid: '210e4c9c-4213-43fc-a68d-041b88a07114', index: 2, style: 'C', value: 55},
                {code: 'AD', name: 'Paralegal', uuid: '210e4c9c-4213-43fc-a68d-041b88a07115', index: 0, style: 'H', value: 250},
                {code: 'AS', name: 'Associate', uuid: '210e4c9c-4213-43fc-a68d-041b88a07116', index: 1, style: 'H', value: 350},
                {code: 'AP', name: 'Partner', uuid: '210e4c9c-4213-43fc-a68d-041b88a07117', index: 2, style: 'H', value: 450}
            ],
        }
    },
    "Matter (Divorce)": {
        Divorce: {
            agreementDate: "2000-06-07",
            createdAt: '2026-03-01T19:46:33.000Z',

            defendantUuid: 'e316302b-56ba-4112-82c3-4e0de4d85349',
            intentCode: 'plaintiff',
            intentDate: '2000-05-06',
            lastCohabitationUuid: 'ca040cba-4eaf-4180-a478-c9e09c0d42d4',
            livingTogether: 'false',
            locationUuid: '621a5f02-f749-49a7-944c-d817900460d0',
            marriageDate: '2000-03-04',
            meta: null,
            plaintiffUuid: 'cd6990a1-208d-4c5b-857a-8f7b19cce59b',
            separationDate: '2001-04-05',
            updatedAt: '2026-03-06T03:01:59.000Z',
            uuid: '53428a80-759d-4910-8b93-a929b5776ac7',

            Children: [
                {
                    birthDate: '2026-01-01T05:00:00.000Z',
                    birthplaceUuid: 'bf4f2976-dab1-45f0-a4cc-1958005afedd',
                    communicationPreferences: 3,
                    createdAt: '2026-03-06T03:11:59.000Z',
                    deceasedDate: null,
                    deceaseUuid: null,
                    displayName: 'Kid1 Doeski',
                    email: null,
                    fax: null,
                    firstName: 'Kid1',
                    flags: 0,
                    gender: 'male',
                    generation: '',
                    lastName: 'Doeski',
                    legalCustody: 'joint',
                    marriageUuid: '53428a80-759d-4910-8b93-a929b5776ac7',
                    middleName: '',
                    phone: null,
                    physicalCustody: 'joint',
                    race: 'unknown',
                    religion: null,
                    Residence: null,
                    residenceUuid: null,
                    ssn: '456-78-9012',
                    updatedAt: '2026-03-06T03:11:59.000Z',
                    userUuid: null,
                    uuid: 'c002b2ce-99fe-4db4-a1b1-c63f6c44bf74',

                    Birthplace: {
                        city: 'Doek1',
                        country: 'US',
                        county: 'Bristol Bay Borough',
                        createdAt: '2026-03-06T03:11:59.000Z',
                        line1: '',
                        line2: '',
                        meta: null,
                        state: 'AK',
                        updatedAt: '2026-03-06T03:11:59.000Z',
                        uuid: 'bf4f2976-dab1-45f0-a4cc-1958005afedd',
                        zipCode: '',
                    }

                }
            ],
            Defendant: {
                driversLicenseNumber: 'B9876543',
                driversLicenseState: 'OH',
                dueDate: null,
                education: 13,
                employerName: 'Meopic ',
                employerPhone: '+18881234567',
                employerUuid: '9e337526-677f-4094-8ad2-101247859f49',
                flags: 0,
                maiden: 'Meo',
                marriages: 2,
                military: 'unknown',
                pregnant: false,
                restore: false,
                title: 'wife',
                uuid: 'e316302b-56ba-4112-82c3-4e0de4d85349',

                Person: {
                    birthDate: '2001-02-01T05:00:00.000Z',
                    communicationPreferences: 3,
                    deceasedDate: null,
                    displayName: 'Jane Leo Meo',
                    email: 'jmeo@valinelaw.com',
                    fax: null,
                    firstName: 'Jane',
                    flags: 0,
                    gender: 'female',
                    generation: '',
                    lastName: 'Leo',
                    maiden: 'Meo',
                    middleName: 'K',
                    phone: '+15713820603',
                    race: 'unknown',
                    religion: null,
                    ssn: '567-89-0123',
                    uuid: 'e316302b-56ba-4112-82c3-4e0de4d85349',
                    Birthplace: {
                        city: 'Baltimore',
                        country: 'US',
                        county: 'Baltimore',
                        createdAt: '2026-03-06T02:59:46.000Z',
                        line1: '',
                        line2: '',
                        meta: null,
                        state: 'MD',
                        updatedAt: '2026-03-06T02:59:46.000Z',
                        uuid: '3aa75b63-83c8-4aa9-8bcd-6dcfea686fe0',
                        zipCode: ''
                    },
                    Residence: {
                        city: 'Charleston',
                        country: 'US',
                        county: 'Greater Bridgeport Planning Region',
                        createdAt: '2026-03-06T03:12:32.000Z',
                        line1: '987 Bird Blvd',
                        line2: '',
                        meta: null,
                        state: 'CT',
                        updatedAt: '2026-03-06T03:12:32.000Z',
                        uuid: '12094435-8891-4a54-8f32-36844d1e04c7',
                        zipCode: '12345'
                    }
                },
                
                Employer: {
                    city: 'Piciomie',
                    country: 'US',
                    county: 'District of Columbia',
                    createdAt: '2026-03-06T01:23:27.000Z',
                    line1: '876 Meopic Lane',
                    line2: '',
                    meta: null,
                    state: 'DC',
                    updatedAt: '2026-03-06T02:59:46.000Z',
                    uuid: '9e337526-677f-4094-8ad2-101247859f49',
                    zipCode: '11555'
                },
            },
            LastCohabitation: {
                city: 'Happville',
                country: 'US',
                county: 'Anderson',
                line1: '7654 Lastabode Lane',
                line2: '',
                simple: false,
                state: 'TN',
                uuid: 'ca040cba-4eaf-4180-a478-c9e09c0d42d4',
                zipCode: '34567',
            },
            Location: {
                city: 'Queens',
                country: 'US',
                county: 'New York',
                createdAt: '2026-03-06T01:23:16.000Z',
                line1: '',
                line2: '',
                meta: null,
                state: 'NY',
                updatedAt: '2026-03-06T03:02:45.000Z',
                uuid: '621a5f02-f749-49a7-944c-d817900460d0',
                zipCode: ''
            },
            Plaintiff: {
                driversLicenseNumber: 'A1234567',
                driversLicenseState: 'VA',
                dueDate: null,
                education: 16,
                employerName: 'Pima Correctional',
                employerPhone: '+18082251234',
                maiden: 'Doeser',
                marriages: 1,
                military: 'unknown',
                pregnant: false,
                restore: false,
                title: 'husband',
                uuid: 'cd6990a1-208d-4c5b-857a-8f7b19cce59b',

                Person: {
                    uuid: 'cd6990a1-208d-4c5b-857a-8f7b19cce59b',
                    displayName: 'Jonathan Does',
                    firstName: "Jonathan",
                    middleName: "",
                    lastName: "Does",
                    generation: "",
                    email: 'jdoe@valinelaw.com',
                    ssn: '123-45-6789',
                    birthDate: '2001-01-01T05:00:00.000Z',
                    deceasedDate: null,
                    phone: '+15713820603',
                    fax: null,
                    communicationPreferences: 3,
                    gender: 'male',
                    religion: null,
                    race: "unknown",
                    flags: 0,
                    Residence: {
                        city: 'Doersville',
                        country: 'US',
                        county: 'Conejos',
                        createdAt: '2026-03-06T02:55:19.000Z',
                        line1: '234 Doersville Pike',
                        line2: '',
                        meta: null,
                        state: 'CO',
                        updatedAt: '2026-03-06T02:55:19.000Z',
                        uuid: 'f581875d-9996-4055-a2d0-b6c07462e95b',
                        zipCode: '45678'
                    },
                    
                    Birthplace: {
                        city: 'Doesly',
                        country: 'US',
                        county: 'Elko',
                        createdAt: '2026-03-06T02:42:57.000Z',
                        line1: '',
                        line2: '',
                        meta: null,
                        state: 'NV',
                        updatedAt: '2026-03-06T02:42:57.000Z',
                        uuid: '18bcd6bc-2d35-4673-804f-54468df8b738',
                        zipCode: ''
                    },
                },
                
                Employer: {
                    city: 'Doemp',
                    country: 'US',
                    county: 'Kent',
                    createdAt: '2026-03-06T01:23:16.000Z',
                    line1: '3456 Employer of Doe',
                    line2: '',
                    meta: null,
                    state: 'DE',
                    updatedAt: '2026-03-06T02:55:19.000Z',
                    uuid: '8d547b8c-9d64-4919-a3b3-fa7985099606',
                    zipCode: '11122'
                },
            },
        },
        Firm: {
            alias: 'VL',
            checkFee: 45,
            initialFee: 75,
            legalName: 'Valine Law PLLC',
            signature: {
                name: "Destin Valine, esq.",
                email: "destin@valinelaw.com"
            }
        },
            
        Matter: {
            assignmentDate: null,
            caption: 'Doe v. Doe',
            caseNumber: '',
            clientUuid: 'b6983122-c74b-432d-af19-895dd25920c3',
            courtUuid: null,
            createdAt: '2026-02-14T21:57:35.000Z',
            filedByUuid: null,
            filingDate: null,
            finalDate: null,
            intakeDate: null,
            judgeUuid: null,
            jury: 0,
            lastFiledByUuid: null,
            lastFilingDate: null,
            matterFlags: 1,
            pacer: '',
            parentType: 'None',
            parentUuid: null,
            status: 'Pending',
            style: 'Domestic',
            updatedAt: '2026-02-20T13:40:51.000Z',
            uuid: '53428a80-759d-4910-8b93-a929b5776ac7',
            Client: {
                assignedToUuid: null,
                billedExpenses: '0.00',
                billedTime: '0.00',
                createdAt: '2026-02-14T21:25:45.000Z',
                due: '0.00',
                lastInvoiced: null,
                meta: null,
                minutes: 6,
                ratesReviewed: '2026-02-14T21:25:45.000Z',
                representationDate: '2026-02-13T05:00:00.000Z',
                retainer: '5000.00',
                retainerAsOf: '2026-02-14T21:25:45.000Z',
                terminationDate: null,
                terminationStyle: '',
                trust: '0.00',
                updatedAt: '2026-02-14T21:25:45.000Z',
                uuid: 'b6983122-c74b-432d-af19-895dd25920c3',
                writeOffs: '0.00',

                Person: {
                    birthDate: null,
                    birthplaceUuid: null,
                    communicationPreferences: 3,
                    createdAt: '2026-02-14T17:20:02.000Z',
                    deceasedDate: null,
                    deceaseUuid: null,
                    displayName: 'John Doe',
                    email: 'jdoe@valinelaw.com',
                    fax: '+1',
                    firstName: 'John',
                    flags: 6,
                    gender: 'unknown',
                    generation: '',
                    lastName: 'Doe',
                    middleName: null,
                    phone: '+1',
                    race: 'unknown',
                    religion: null,
                    residenceUuid: null,
                    ssn: null,
                    updatedAt: '2026-02-15T22:08:32.000Z',
                    userUuid: '279d1627-3505-4e58-8ca5-2b158a299d87',
                    uuid: 'b6983122-c74b-432d-af19-895dd25920c3'
                },
                rates: [
                    {
                        code: 'AS',
                        createdAt: '2026-02-08T17:18:39.000Z',
                        index: 0,
                        name: 'Associate Attorney',
                        style: 'H',
                        updatedAt: '2026-02-08T17:18:39.000Z',
                        uuid: '70d53760-cc50-4e23-8311-cb25da86431f',
                        value: 350
                    },
                    {
                        code: 'PA',
                        createdAt: '2026-02-08T17:18:08.000Z',
                        index: 0,
                        name: 'Paralegal or Assistant',
                        style: 'H',
                        updatedAt: '2026-02-08T17:18:08.000Z',
                        uuid: 'a26615f3-f9a4-4242-bdb4-b4574b0adda5',
                        value: 250
                    },
                    {
                        code: 'AP',
                        createdAt: '2026-02-08T17:19:30.000Z',
                        index: 0,
                        name: 'Partner',
                        style: 'H',
                        updatedAt: '2026-02-08T17:19:30.000Z',
                        uuid: 'f11df57e-bbd0-456e-a3cb-2b79c91bc8eb',
                        value: 450
                    }
                ],
            },
            Court: {
                addressUuid: '769c64a2-496e-4f1b-be76-4861b7cf9d43',
                citation: 'Va. Cir. Ct. Fairfax',
                createdAt: '2026-02-08T19:40:05.000Z',
                district: 'Fairfax County',
                division: 'Circuit',
                email: null,
                fax: null,
                full: 'Fairfax County Circuit',
                name: 'FFXC',
                Address: {
                    city: 'Fairfax',
                    country: 'US',
                    county: null,
                    createdAt: '2026-02-08T19:40:05.000Z',
                    line1: '4110 Chain Bridge Road',
                    line2: '',
                    meta: null,
                    state: 'VA',
                    updatedAt: '2026-02-08T19:40:05.000Z',
                    uuid: '769c64a2-496e-4f1b-be76-4861b7cf9d43',
                    zipCode: '22030'
                }
            },
            Parties: [
                {
                    attorney: 0,
                    birthDate: null,
                    birthplaceUuid: null,
                    communicationPreferences: 3,
                    createdAt: '2026-02-14T17:20:02.000Z',
                    deceasedDate: null,
                    deceaseUuid: null,
                    displayName: 'John Doe',
                    email: 'jdoe@valinelaw.com',
                    fax: '+1',
                    firstName: 'John',
                    flags: 6,
                    gender: 'unknown',
                    generation: '',
                    lastName: 'Doe',
                    middleName: null,
                    phone: '+1',
                    race: 'unknown',
                    religion: null,
                    residenceUuid: null,
                    ssn: null,
                    updatedAt: '2026-02-15T22:08:32.000Z',
                    userUuid: '279d1627-3505-4e58-8ca5-2b158a299d87',
                    uuid: 'b6983122-c74b-432d-af19-895dd25920c3',
                    roles: [
                        { value: 'Plaintiff', label: 'Plaintiff' }
                    ]
                },
                {
                    attorney: 1,
                    birthDate: null,
                    birthplaceUuid: null,
                    communicationPreferences: 3,
                    createdAt: '2026-02-08T11:30:54.000Z',
                    deceasedDate: null,
                    deceaseUuid: null,
                    displayName: 'Destin Valine',
                    email: 'destin@valinelaw.com',
                    fax: '+1',
                    firstName: 'Destin',
                    flags: 8,
                    gender: 'unknown',
                    generation: '',
                    lastName: ' Valine',
                    middleName: '',
                    phone: '+15713820603',
                    race: 'unknown',
                    religion: null,
                    residenceUuid: 'deb1937b-f42e-4a71-b2b7-3fcdef7f2043',
                    roles: [
                        {
                            value: 'Plaintiff',
                            label: 'Plaintiff'
                        }
                    ],
                    ssn: null,
                    updatedAt: '2026-02-15T15:16:53.000Z',
                    userUuid: '8c1a6a62-da70-4ba7-b63e-f87203117338',
                    uuid: '4248a518-77c8-4f67-a147-c861c129d60c'
                },{
                    attorney: 0,
                    birthDate: null,
                    birthplaceUuid: null,
                    communicationPreferences: 3,
                    createdAt: '2026-02-14T17:20:02.000Z',
                    deceasedDate: null,
                    deceaseUuid: null,
                    displayName: 'Jane Doe',
                    email: 'jane.doe@valinelaw.com',
                    fax: '+13215671234',
                    firstName: 'Jane',
                    flags: 6,
                    gender: 'unknown',
                    generation: '',
                    lastName: 'Doe',
                    middleName: null,
                    phone: '+1',
                    race: 'unknown',
                    religion: null,
                    residenceUuid: null,
                    ssn: null,
                    updatedAt: '2026-02-15T22:08:32.000Z',
                    userUuid: '279d1627-3505-4e58-8ca5-2b158a299d87',
                    uuid: 'b6983122-c74b-432d-af19-895dd25920c3',
                    roles: [
                        { value: 'Defendant', label: 'Defendant' }
                    ]
                }
            ]
        }
    },
    "Matter (Name Change)": {
        "Firm": {
            "legalName": "Dewey, Screwem, & Howe PC",
            "alias": "DSH",
            "initialFee": 75,
            "checkFee": 45
        },
        "Matter": {
            "uuid": "1b9b2e45-7d62-4f36-bc86-b8fe1040d747",
            "clientUuid": "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
            "parentUuid": null,
            "parentType": "None",
            "caption": "Ima Outsider Name Change",
            "style": "Other",
            "matterFlags": 256,
            "courtUuid": null,
            "caseNumber": null,
            "intakeDate": "2026-05-14T09:51:31.000Z",
            "filingDate": null,
            "filedByUuid": null,
            "lastFilingDate": null,
            "lastFiledByUuid": null,
            "judgeUuid": null,
            "assignmentDate": null,
            "finalDate": null,
            "status": "Pending",
            "pacer": null,
            "jury": null,
            Court: {
                citation: 'Va. Cir. Ct. Fairfax',
                createdAt: '2026-02-08T19:40:05.000Z',
                district: 'Fairfax County',
                division: 'Circuit',
                email: null,
                fax: null,
                full: 'Fairfax County Circuit',
                name: 'FFXC',
                Address: {
                    city: 'Fairfax',
                    country: 'US',
                    county: null,
                    createdAt: '2026-02-08T19:40:05.000Z',
                    line1: '4110 Chain Bridge Road',
                    line2: '',
                    meta: null,
                    state: 'VA',
                    updatedAt: '2026-02-08T19:40:05.000Z',
                    uuid: '769c64a2-496e-4f1b-be76-4861b7cf9d43',
                    zipCode: '22030'
                }
            },
            "Client": {
                "uuid": "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
                "assignedToUuid": null,
                "meta": null,
                "createdAt": "2025-12-14T23:05:35.000Z",
                "updatedAt": "2026-01-09T21:02:46.000Z",
                "Person": {
                    "uuid": "b182ccf7-59d4-11f0-a2ef-0ed2cd1b87df",
                    "displayName": "Ima Outsider",
                    "firstName": "Ima",
                    "middleName": "",
                    "lastName": "Outsider",
                    "generation": "",
                    "email": "imaoutsider@valinelaw.com",
                    "ssn": null,
                    "birthDate": null,
                    "deceasedDate": null,
                    "phone": "+12125551000",
                    "fax": "+12125551005",
                    "communicationPreferences": 3,
                    "userUuid": "bae4470f-08bb-45e8-a07b-c8792e7d987a",
                    "birthplaceUuid": null,
                    "deceaseUuid": null,
                    "residenceUuid": "1e30f3f4-2446-4a24-b722-69665271d3d2",
                    "gender": "unknown",
                    "religion": null,
                    "race": "unknown",
                    "flags": 6,
                    "createdAt": "2025-07-05T15:17:27.000Z",
                    "updatedAt": "2025-12-18T12:17:39.000Z"
                }
            }
        },
        "Parties": [],
        "NameChange": {
            "uuid": "1b9b2e45-7d62-4f36-bc86-b8fe1040d747",
            "currentFirstName": "Ima",
            "currentMiddleName": "Bigg",
            "currentLastName": "Outsider",
            "currentGeneration": "",
            "newFirstName": "Ima",
            "newMiddleName": "Lyttle",
            "newLastName": "Outsider",
            "newGeneration": "Jr",
            "Residence": {
                "simple": false,
                "line1": "123 Sesame Street",
                "line2": "",
                "city": "Leesburg",
                "state": "VA",
                "county": "Loudoun",
                "zipCode": "20176",
                "country": "US",
                "uuid": "1ed73aaa-2a0b-4d46-aefe-6e67ac3a9c97",
                "suggestionMenu": {
                    "show": false,
                    "target": null,
                    "path": null
                }
            },
            "birthState": "AK",
            "birthCountry": "US",
            "dateOfBirth": "1985-05-01T00:00:00.000Z",
            "birthFirstName": "Ima",
            "birthMiddleName": "Jane",
            "birthLastName": "Smythe",
            "birthGeneration": "",
            "reason": "Identity confusion, promoting smallness",
            "felon": false,
            "incarcerated": false,
            "probation": true,
            "registered": false,
            "parent1FirstName": "Ann",
            "parent1MiddleName": "Posh",
            "parent1LastName": "Smythe",
            "parent1Generation": "",
            "parent1Maiden": "Spyce",
            "parent2FirstName": "Charles",
            "parent2MiddleName": "Kenneth",
            "parent2LastName": "Smyth",
            "parent2Generation": "IV",
            "parent2Maiden": "",
            "meta": {
                "previous": [
                    {
                        "firstName": "Ima",
                        "middleName": "Bigg",
                        "lastName": "Outsider",
                        "generation": "",
                        "reason": "MA"
                    }
                ],
                "probation": {
                    "court": "Fairfax"
                }
            }
        }
    },
    "Payroll Check": {
        checkNumber: 1000,
        endsOn: "2026-01-30",
        grossPay: "289.50",
        hoursWorked: "16.08",
        netPay: "208.92",
        payDate: "2026-02-06",
        payeeName: "John Doe",
        paymentMethod: "print",
        startsOn: "2026-01-17",
        totalDeductions: "20.00",
        totalTaxes: "60.58",
        meta: {
            ytd: {
                gross: "0.00",
                taxes: "0.00",
                deductions: "0.00"
            },
            results: {
                taxes: {
                    total: "60.58"
                },
                earnings: {
                    grossPay: "289.5",
                    hourlyRate: "18",
                    regularPay: "289.5",
                    ovetimePay: "0"
                }
            }
        },
        deductions: [
            {
                code: "EMP_OT",
                caption: "Employee directed",
                preTax: false,
                amount: "5.00"
            },
            {
                code: "INS_MED",
                caption: "Medical Insurance",
                preTax: true,
                amount: "15.00"
            },
            {
                code: "EMP_401K",
                caption: "401K Contribution",
                preTax: true,
                amount: "2.90"
            }
        ],
        taxes: [
            {
                code: "VA_WH",
                caption: "Virginia Withholding",
                amount: "9.48"
            },
            {
                code: "FED_WH",
                caption: "Federal Withholding",
                amount: "28.95"
            },
            {
                code: "FICA_MED",
                caption: "Medicare (Employee)",
                amount: "4.20"
            },
            {
                code: "FICA_SS",
                caption: "Social Security (Employee)",
                amount: "17.95"
            }
        ]
    }
};
